import Button from '@material-ui/core/Button';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import timeIcon from '../../common/images/Group 20.png';
import peopleIcon from '../../common/images/Layer 2 (1).svg';
import payrollIcon from '../../common/images/Layer 2 (2).svg';
import assetIcon from '../../common/images/Layer 2 (3).svg';
import myEdgeIcon from '../../common/images/myedge_launch_icon.svg';
import taskIcon from '../../common/images/task_launch_icon.svg';
import referencingIcon from '../../common/images/referencing_launch_icon.svg';
import performanceIcon from '../../common/images/performance.svg';
import recruitIcon from '../../common/images/recruit.svg';
import useUserPermission from 'hooks/useUserPermission';
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    minWidth: '130px'
  }
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {}
}))(MenuItem);

let routes = [
  {
    name: 'People',
    permission: 'access_hr',
    path: '/hr?type=all-employees&tab=all-employee-home',
    pathAs: '/hr',
    icon: peopleIcon
  },
  {
    name: 'Payroll',
    permission: 'access_payroll',
    path: '/payroll?tab=home',
    icon: payrollIcon,
    pathAs: '/payroll'
  },
  {
    name: 'Attendance',
    permission: 'access_attendance',
    path: '/time-and-attendance?tab=daily-attendance',
    icon: timeIcon,
    pathAs: '/time-and-attendance'
  },
  {
    name: 'Recruit',
    permission: 'access_recruits',
    path: '/recruit?screen=home',
    icon: recruitIcon,
    pathAs: '/recruit'
  },
  {
    name: 'Rota & Shifts',
    permission: 'access_shift',
    path: '/shift-rota',
    icon: timeIcon,
    pathAs: '/shift-rota'
  },
  {
    name: 'Performance',
    permission: 'access_performance',
    path: '/performance',
    icon: performanceIcon,
    pathAs: '/performance'
  },
  {
    name: 'Referencing',
    permission: 'access_referencing',
    path: '/reference',
    icon: referencingIcon,
    pathAs: '/reference'
  },
  {
    name: 'MyEdge',
    permission: 'access_myedge',
    path: '/myedge',
    icon: myEdgeIcon,
    pathAs: '/myedge'
  },
  {
    name: 'Assets',
    permission: 'access_assets',
    path: '/assets?tab=home',
    icon: assetIcon,
    pathAs: '/assets'
  },
  {
    name: 'Task',
    permission: 'access_task',
    path: '/tasks',
    icon: taskIcon,
    pathAs: '/tasks'
  }
];

export default function LaunchPad() {
  const [anchorEl, setAnchorEl] = useState(null);
  const { location } = useHistory();

  const { data } = useUserPermission();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const permissionCode = data?.permissions?.map((item) => item.codename) || [];

  const routesAccess = data?.is_owner
    ? routes
    : permissionCode?.reduce((curr, route) => {
        const routePermission = routes.find(
          (item) => item.permission === route
        );

        if (routePermission) {
          curr.push(routePermission);
        }
        return curr;
      }, []);

  const handleRouteChange = (item) => {
    // push(item.path);
    window.open(item.path, '_blank');
    handleClose();
  };

  let route = routes.find(
    (item) =>
      item.path.includes(location.pathname.split('/')[1]) ||
      item.path.includes(location.pathname.split('/')[2])
  );
  const getActive = () => {
    return route?.name || 'Launchpad';
  };

  const getActiveIcon = () => {
    return route?.icon || null;
  };
  return (
    <LaunchPad.Wrapper>
      <Button onClick={handleClick}>
        {getActiveIcon() && <Icon src={getActiveIcon()} alt='' />} {getActive()}
        {Boolean(anchorEl) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Button>
      <StyledMenu
        id='customized-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {routesAccess.map((item, index) => (
          <StyledMenuItem
            key={item.name ?? index}
            onClick={() => handleRouteChange(item)}
            style={{ height: 43, borderBottom: ' 1px solid #f2f2f2' }}
          >
            <Icon src={item.icon} alt='' />{' '}
            <StyledListItemText primary={item?.name} />
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </LaunchPad.Wrapper>
  );
}

LaunchPad.Wrapper = styled.div`
  button {
    background: #f2f2f2;
    border-radius: 61px;
    font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    color: #878787;
    height: 35px;
    padding: 0 15px;
  }
`;

const Icon = styled.img`
  width: 19px;
  height: 19px;
  margin-right: 10px;
`;

const StyledListItemText = styled(ListItemText)`
  span {
    font-weight: 400;
    font-size: 14px;
    line-height: 128.86%;
    color: #545454;
  }
`;
